import { Component, Input, OnChanges } from '@angular/core';
import { SimpleTravel } from '../product.types';
import { SimpleTravelService } from '../simple-travel.service';
import { ToastrService } from 'ngx-toastr';

import { Translations } from '../../../assets/translations';
import { SharedService } from '../../shared/shared.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'b4a-product-simple-travel-list',
  templateUrl: './simple-travel-list.component.html',
  styleUrls: ['./simple-travel-list.component.css']
})
export class SimpleTravelListComponent implements OnChanges {
  window; // offer window licence

  @Input()
  travels;

  @Input()
  clickedNew;
  changesCount = 0;

  order: string = 'at';
  reverse: boolean = false;

  disabledOfferNumberEntries: any[];
  test;

  spinnerLoading = false;
  success = ''; // success message for pop up window
  error = ''; // errror message for pop up window

  tripNotActivated = ''
  tripNotDeactivated = ''
  constructor(private simpleTravelService: SimpleTravelService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private translate: TranslateService) {
     let sessionData = JSON.parse( localStorage.getItem('sessionData'))
      this.window = sessionData.homepage.windows


    this.translate.getTranslation(this.translate.currentLang).subscribe(
      done => {
         this.tripNotActivated = done['pop-up-message'].tripNotActivated
         this.tripNotDeactivated = done['pop-up-message'].tripNotDeactivated
         this.success = done['pop-up-message'].success
         this.error = done['pop-up-message'].error
      })

      this.translate.onLangChange.subscribe(
        changed => {
        this.translate.get('pop-up-message.tripNotActivated').subscribe(
          done => this.tripNotActivated = done
        )
        this.translate.get('pop-up-message.tripNotDeactivated').subscribe(
          done => this.tripNotDeactivated = done
        )
        this.translate.get('pop-up-message.success').subscribe(
          done => this.success = done
        )
        this.translate.get('pop-up-message.error').subscribe(
          done => this.error = done
        )
      })

    this.sharedService.getSpinerloading().subscribe( spinnerLoading => {
      if (spinnerLoading === true) {
        this.spinnerLoading = true;
      }else {
        this.spinnerLoading = false;
      }
    })

    this.disabledOfferNumberEntries = new Array();
    for (let i = 1; i < 5; i++) {
      this.disabledOfferNumberEntries.push({
        at: i,
        disabled: false
      })
    }
   }

   ngOnChanges(changes) {
    if (changes['travels']) {
     if (this.travels !== undefined) {
       for (let travel of this.travels){
         for (let disabled of this.disabledOfferNumberEntries){
           if (travel.at === disabled.at) {
             disabled.disabled = true;
           }
         }
       }
     }
    }
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }


  deleteSimpleTravel(travel, i) {
    let travelType;
    this.sharedService.getUserTravel().subscribe(
      data => travelType = data
    )
    if (travelType === 'simpleTravel') {
      this.simpleTravelService.deleteSimpleTravel(travel).subscribe(
        data => { this.toastr.success(this.success),
          this.travels.splice(i, 1)},
        err =>  this.toastr.error(this.error));
    }else {
      this.simpleTravelService.deleteBasicTravel(travel).subscribe(
        data => { this.toastr.success(this.success),
          this.travels.splice(i, 1)},
          err =>  this.toastr.error(this.error));
    }
  }

  setTravelStatus(travel) {
    let tempAT = travel.at
    if (travel.active === true) {
      travel.active = false;
      travel.at = null;
      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        success => {},
        err => {this.toastr.error(this.tripNotDeactivated), travel.active = true, travel.at = tempAT})
    }else {
      travel.active = true;
      this.simpleTravelService.saveSimpleTravel(travel).subscribe(
        success => {},
        err => { this.toastr.error(this.tripNotActivated), travel.active = false, travel.at = tempAT})
    }
  }

  changeOfferWindowNumber(at, travel, travelIndex) {
    this.spinnerLoading = true
    let travelID = null;
    for (let i = 0; i < this.travels.length; i++) {
      if (this.travels[i].at === Number(at)) {
        travelID = i;
        break;
      }
    }
    // this.travels[travelID].at = null
    if (travelID === null) {
      this.changeTravelID(at, travel) // means first travel with that window number
    }else {
      this.travels[travelID].at = null
      this.simpleTravelService.saveSimpleTravel(this.travels[travelID]).subscribe(
        success => { this.changeTravelID(at, travel) },
        err => {this.toastr.error(this.tripNotActivated), this.travels[travelIndex].at = Number(travel.at), this.travels[travelID].at = null,  this.spinnerLoading = false})
    }
  }

  changeTravelID(at, travel) {
    travel.at = Number(at);
    this.simpleTravelService.saveSimpleTravel(travel).subscribe(
    success => { this.spinnerLoading = false},
    err => {this.toastr.error(this.error), this.spinnerLoading = false})
  }
}



// WEBPACK FOOTER //
// ./src/app/product/simple-travel-list/simple-travel-list.component.ts